module.exports = __webpack_public_path__ + "img/course-1-6.d31ab0bd.jpeg";